// src/App.jsx
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import store from './store';

// Layouts
import ErrorBoundary from './components/common/ErrorBoundary';
import ProtectedRoute from './components/common/ProtectedRoute';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
import EmailConfirmation from './pages/EmailConfirmation';
import DashboardModern from './pages/DashboardModern';
import MissionsPage from './pages/MissionsPage';
import MissionDetailPage from './pages/MissionDetailPage';
import ProfileModern from './pages/ProfileModern';
import History from './pages/History';
import NotFound from './pages/NotFound';

// Styles
import 'react-toastify/dist/ReactToastify.css';
import 'leaflet/dist/leaflet.css';
import './styles/index.css';
import './styles/driver.css';

function App() {
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <BrowserRouter>
          <Routes>
            {/* Routes publiques */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/confirm-email/:token" element={<EmailConfirmation />} />

            {/* Routes protégées - Driver */}
            <Route
              path="/driver"
              element={
                <ProtectedRoute allowedRoles={['driver']}>
                  <DashboardModern />
                </ProtectedRoute>
              }
            />

            <Route
              path="/driver/missions"
              element={
                <ProtectedRoute allowedRoles={['driver']}>
                  <MissionsPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/driver/mission/:id"
              element={
                <ProtectedRoute allowedRoles={['driver']}>
                  <MissionDetailPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/driver/profile"
              element={
                <ProtectedRoute allowedRoles={['driver']}>
                  <ProfileModern />
                </ProtectedRoute>
              }
            />

            <Route
              path="/driver/history" 
              element={
                <ProtectedRoute allowedRoles={['driver']}>
                  <History />
                </ProtectedRoute>
              } 
            />

            {/* Redirections */}
            <Route path="/" element={<Navigate to="/driver" replace />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>

        {/* Toast Notifications */}
        <ToastContainer 
          position="bottom-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          style={{ zIndex: 9999 }}
        />
      </Provider>
    </ErrorBoundary>
  );
}

export default App;